import React from 'react';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { Banner } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import parentMessages from '../messages';
import TableLayoutV2 from '../../../components/TableLayoutV2';
import useRegularAssistancePayments from './hooks';
import { BASE_TABLE_LAYOUT_SX } from '../constants';

const RegularAssistancePayments = ({
  show,
  regularAssistancePayments = [],
  isGated = false,
  hasVariance = false,
  isReadOnly = false,
  onSaveApprovedAmount,
  hasValidationErrors = false,
  isLoading = false,
  propertyId,
  canManage,
}) => {
  const {
    allColumnsHidden,
    baseTableProps,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    rowsLoading,
    name,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    totalCount,
  } = useRegularAssistancePayments({
    regularAssistancePayments,
    hasVariance,
    isReadOnly,
    onSaveApprovedAmount,
    propertyId,
    canManage,
  });

  if (!show) {
    return null;
  }

  return (
    <TableLayoutV2 name={name} fullPage sx={BASE_TABLE_LAYOUT_SX}>
      {(height) => {
        return (
          <>
            <TableHeader
              title={<FormattedMessage {...messages.tableTitle} />}
              count={count}
              totalCount={totalCount}
            />
            {isGated && rows?.length === 0 ? (
              <Banner
                status="warning"
                message={baseTableProps.intl.formatMessage(
                  parentMessages.rapAdjustmentsGatingBanner,
                )}
              />
            ) : null}
            {hasValidationErrors ? (
              <Banner
                status="warning"
                message={baseTableProps.intl.formatMessage(
                  messages.validationBlockingBanner,
                )}
              />
            ) : null}
            {rows.length > 0 ? (
              <Banner
                status="info"
                message={
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {baseTableProps.intl.formatMessage(
                      messages.somethingOffBanner,
                    )}
                  </span>
                }
              />
            ) : null}
            <Table
              {...baseTableProps}
              name={name}
              allColumnsHidden={allColumnsHidden}
              columnOptions={columnOptions}
              count={count}
              dateState={dateState}
              emptyStateMessage={baseTableProps.intl.formatMessage(
                messages.emptyStateMessage,
              )}
              filterState={filterState}
              filterTypeState={filterTypeState}
              handleColumnChange={handleColumnChange}
              handleDateSubmit={handleDateSubmit}
              handleFilterChange={handleFilterChange}
              handleFilterTypeChange={handleFilterTypeChange}
              handleSearchSubmit={handleSearchSubmit}
              handleSortChange={handleSortChange}
              headers={filteredHeaders}
              height={height}
              isLoading={isLoading || rowsLoading}
              order={order}
              orderBy={orderBy}
              rows={rows}
              searchState={searchState}
              selectedColumns={selectedColumns}
              totalCount={totalCount}
            />
          </>
        );
      }}
    </TableLayoutV2>
  );
};

export default RegularAssistancePayments;
